import { render, staticRenderFns } from "./LawAuthorityRepresentativeForm.vue?vue&type=template&id=1a944d54&"
import script from "./LawAuthorityRepresentativeForm.vue?vue&type=script&lang=js&"
export * from "./LawAuthorityRepresentativeForm.vue?vue&type=script&lang=js&"
import style0 from "./LawAuthorityRepresentativeForm.vue?vue&type=style&index=0&id=1a944d54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports